import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { FlexBetween, FlexCenter } from '../../../../global/commonStyle';

const MainDiv = styled.div`
  max-width: 662px;
  width: 100%;
`;
const Heading = styled.div`
  ${Typography.heading_md}
  color: var(--text-primary);
`;

const Box = styled.div`
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  border-radius: var(--border-radius-8);
  ${FlexCenter}
  flex-direction: column;
  gap: var(--space-20);
  padding-block: var(--space-36);
  ${mobile_xl(css`
    padding-block: var(--space-32);
  `)}
`;
const Detail = styled.div`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  margin-bottom: var(--space-24);
  ${mobile_xl(css`
    margin-top: var(--space-8);
  `)}
`;
const Tag = styled.div`
  ${Typography.body_sm}
  color: var(--text-secondary);
  background-color: var(--neutral-secondary);
  padding: var(--space-2) var(--space-6);
  border-radius: var(--border-radius-6);
  border: 0.5px solid transparent;
`;
const FirstCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  cursor: pointer;
  ${mobile_xl(
    css`
      gap: var(--space-2);
    `
  )}
`;

const ProjectCard = styled.div`
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  border-radius: var(--border-radius-8);
`;
const FirstProjects = styled.div`
  padding: var(--space-12) var(--space-16);
  ${FlexBetween}
  gap: var(--space-12);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
  .active {
    border-radius: var(--border-radius-6);
    background: var(--neutral-secondary);
  }
`;
const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: 100%;
`;

const Name = styled.div`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;

const Description = styled.div`
  ${Typography.body_md}
  color: var(--text-secondary);
`;

const BoxLoading = styled.div`
  max-width: 662px;
  width: 100%;
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  .loading-animation {
    overflow: hidden;
  }

  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
const FirstLoading = styled.div`
  padding: var(--space-16);
  ${FlexBetween}
  gap: var(--space-20);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
`;

const RightLoading = styled.div`
  width: 18px;
  height: 18px;
  border-radius: var(--border-radius-4);
  background-color: var(--background-muted);
`;

const LeftLoading = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;
const TopLoading = styled.div`
  width: 136px;
  height: 9px;
  border-radius: var(--border-radius-6);
  background-color: var(--background-muted);
`;

const BottomLoading = styled.div`
  width: 280px;
  height: 9px;
  border-radius: var(--border-radius-6);
  background-color: var(--background-muted);
`;

const Group = styled.div`
  max-width: 503px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: var(--space-5) var(--space-24) var(--space-24);
  gap: var(--space-16);
  ${mobile_xl(css`
    padding: var(--space-0) var(--space-20) var(--space-80);
    gap: var(--space-12);
  `)}
`;

const TitleSetting = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;
const HeaderTask = styled.div`
  ${FlexBetween}
`;
const Tasklist = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
`;
const Task = styled.div`
  ${FlexBetween}
  padding: var(--space-12) var(--space-16);
  gap: var(--space-12);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
  .active {
    border-radius: var(--border-radius-6);
    background: var(--neutral-secondary);
  }
`;
const TaskText = styled.div`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;

export {
  MainDiv,
  Heading,
  Box,
  Detail,
  Bottom,
  Tag,
  FirstCard,
  ProjectCard,
  FirstProjects,
  Left,
  Name,
  Description,
  BoxLoading,
  FirstLoading,
  RightLoading,
  LeftLoading,
  TopLoading,
  BottomLoading,
  TitleSetting,
  Group,
  HeaderTask,
  Tasklist,
  Task,
  TaskText
};
